/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Round_EndedInputs */

const en_us2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round ended`)
};

const pt_br2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodada encerrada`)
};

const es_419_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ronda terminada`)
};

const pt_pt2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ronda terminada`)
};

const fr_fr2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manche terminée`)
};

const de_de2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde beendet`)
};

const it_it2_clubs_round_ended = /** @type {(inputs: Clubs_Round_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turno concluso`)
};

/**
* | output |
* | --- |
* | "Round ended" |
*
* @param {Clubs_Round_EndedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_round_ended = /** @type {((inputs?: Clubs_Round_EndedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Round_EndedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_round_ended(inputs)
	if (locale === "es-419") return es_419_clubs_round_ended(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_round_ended(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_round_ended(inputs)
	if (locale === "de-DE") return de_de2_clubs_round_ended(inputs)
	if (locale === "it-IT") return it_it2_clubs_round_ended(inputs)
	return en_us2_clubs_round_ended(inputs)
});
export { clubs_round_ended as "clubs.round_ended" }